import { useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Globe2, ExternalLink, Copy, Eye, EyeOff } from "lucide-react";

export default function SiteListing({ site, onChange }) {
  const [listed, setListed] = useState(site?.listed !== false);
  const [busy, setBusy] = useState(false);
  if (!site?.public_slug) return null;
  const url = `${window.location.origin}/api/swap/${site.public_slug}`;

  const toggle = async () => {
    setBusy(true);
    const next = !listed;
    try {
      await api.post("/site/listing", { listed: next });
      setListed(next);
      toast.success(next ? "Your public swap listing is live." : "Your public listing is hidden.");
      onChange && onChange();
    } catch {
      toast.error("Couldn't update your listing.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-xl border border-white/10 bg-zinc-900/60 p-5" data-testid="site-listing-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-lg border border-blue-500/20 bg-blue-500/10 text-blue-400 flex items-center justify-center"><Globe2 size={16} /></div>
          <div>
            <div className="text-sm font-medium">Public swap listing <span className="text-emerald-400">· SEO</span></div>
            <div className="text-xs text-muted-foreground">A domain-masked page that advertises your site for backlink swaps and gets indexed by Google.</div>
          </div>
        </div>
        <button onClick={toggle} disabled={busy} data-testid="listing-toggle"
          className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${listed ? "border-emerald-500/30 bg-emerald-500/10 text-emerald-400 hover:bg-emerald-500/20" : "border-white/10 bg-white/5 text-muted-foreground hover:text-foreground"}`}>
          {listed ? <Eye size={13} /> : <EyeOff size={13} />} {listed ? "Listed" : "Hidden"}
        </button>
      </div>
      {listed && (
        <div className="mt-3 flex items-stretch gap-2">
          <a href={url} target="_blank" rel="noreferrer" data-testid="listing-url"
            className="flex-1 min-w-0 rounded-lg bg-zinc-950 border border-white/10 px-3 py-2.5 font-mono text-[12px] text-blue-400 hover:underline truncate flex items-center gap-1.5">
            <ExternalLink size={12} className="shrink-0" /><span className="truncate">{url}</span>
          </a>
          <button onClick={() => { navigator.clipboard.writeText(url); toast.success("Listing URL copied"); }}
            data-testid="listing-copy" className="rounded-lg border border-white/10 bg-white/5 hover:bg-white/10 px-3 shrink-0">
            <Copy size={14} />
          </button>
        </div>
      )}
    </div>
  );
}
